<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Eventos" pageTitle="Eventos" />
            <CalendarContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import CalendarContent from '../Calendar/CalendarContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'CalendarPage',
    components: {
        MainHeader,
        PageTitle,
        CalendarContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>